import React, { useEffect, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import OrderPage from './components/orderPage';
import AdminDashboard from './components/admin/adminDashboard';
import LoginPage from './pages/LoginPage';
import TableOrderLogin from './pages/TableOrderLogin';
import TableOrderPage from './pages/TableOrderPage';
import SignupPage from './pages/SignupPage';
import LandingPage from './pages/landing/LandingPage';
import DownloadPage from './pages/DownloadPage';
import PrivacyPage from './pages/PrivacyPage';
import AccountDeletionPage from './pages/AccountDeletionPage';
import { preloadByPriority } from './utils/imagePreloader';
import './App.css';

const MasterLogin = lazy(() => import('./pages/master/MasterLogin'));
const MasterDashboard = lazy(() => import('./pages/master/MasterDashboard'));
const SimulationPage = lazy(() => import('./pages/SimulationPage'));
const SimulationTablePage = lazy(() => import('./pages/SimulationTablePage'));

function App() {
  useEffect(() => {
    // 앱 시작 시 유니온 데이터가 있는지 확인
    const unionCategories = localStorage.getItem('unionCategories');
    
    // 유니온 데이터가 없을 때만 초기화
    if (!unionCategories) {
      const existingMenuData = localStorage.getItem('menuData');
      const existingCategories = localStorage.getItem('categories');
      
      // 기존 데이터가 있으면 제거
      if (existingMenuData || existingCategories) {
        console.log('No Union data found, clearing existing menu data...');
        localStorage.removeItem('menuData');
        localStorage.removeItem('categories');
        
        // 빈 데이터로 초기화
        localStorage.setItem('menuData', JSON.stringify({}));
        localStorage.setItem('categories', JSON.stringify([]));
      }
    } else {
      console.log('Union data found, keeping existing data');
    }
    
    // 이미지 프리로드 실행
    // 옵션 1: 우선순위별 로드 (권장)
    preloadByPriority();
    
    // 옵션 2: 모든 리소스 한번에 로드
    // preloadAllResources().then(result => {
    //   console.log('Preload result:', result);
    // });
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/order" element={<OrderPage />} />
          {/* /start(데모)는 별도 빌드(DemoApp)로 분리 → nginx가 woworder-demo 폴더에서 서빙 */}
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/login" element={<LoginPage />} />
          {/* 테이블오더(태블릿) — 설정용 로그인 + 무세션 고정 주문 화면 */}
          <Route path="/login/tableorder" element={<TableOrderLogin />} />
          <Route path="/tableorder/:storeUid/:tableCode" element={<TableOrderPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/download" element={<DownloadPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/account-deletion" element={<AccountDeletionPage />} />
          <Route path="/master/login" element={
            <Suspense fallback={<div style={{background:'#0f1115',minHeight:'100vh'}} />}>
              <MasterLogin />
            </Suspense>
          } />
          <Route path="/master" element={
            <Suspense fallback={<div style={{background:'#0f1115',minHeight:'100vh'}} />}>
              <MasterDashboard />
            </Suspense>
          } />
          {/* 통합 시뮬레이션 (매장 36) */}
          <Route path="/simulation" element={
            <Suspense fallback={<div style={{background:'#f4f5f7',minHeight:'100vh'}} />}>
              <SimulationTablePage />
            </Suspense>
          } />
          <Route path="/simulation/okpos" element={
            <Suspense fallback={<div style={{background:'#0f1115',minHeight:'100vh'}} />}>
              <SimulationPage posType="okdc" />
            </Suspense>
          } />
          <Route path="/simulation/unionpos" element={
            <Suspense fallback={<div style={{background:'#0f1115',minHeight:'100vh'}} />}>
              <SimulationPage posType="union" />
            </Suspense>
          } />
          <Route path="/simulation/wowpos" element={
            <Suspense fallback={<div style={{background:'#0f1115',minHeight:'100vh'}} />}>
              <SimulationPage posType="wowpos" />
            </Suspense>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;